// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2757) return "static/chunks/2757-e39a6f5823cff1c2.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5592 ? "c15bf2b0" : chunkId) + "." + {"1478":"0cbb7f94778189fa","3246":"c2d3b94d9853d7ee","5203":"77ddae019d833612","5211":"0f4a39fe754f3fdf","5415":"bcab4c26f8d27a73","5592":"10d1ab67ab8127e3","6218":"64795a9c47fe7365","8081":"ae3585f741752711"}[chunkId] + ".js";
};